export default {
    _prefix: "ScorableQuestionGroup",
    labels: {
        na: "Question group is not applicable",
    },
    tooltip: {
        scale: "Scale Factor",
        critical: (data: { total: number; max: number }) =>
            "Critical Score: {{total}}/{{max}}",
        score: (data: { total: number; max: number }) =>
            "Score: {{total}}/{{max}}",
    },
    ariaLabels: {
        groupScoreScaleEditor: (data: { value: number }) =>
            "Group Score Scaling Factor: {{value}}",
        score: (data: { percentage: string }) => "Score: {{percentage}}",
        criticalScore: (data: { percentage: string }) =>
            "Critical Score: {{percentage}}",
    },
};
